import PropTypes from "prop-types";
import { getBadgeText } from "../getBadgeText";
import styles from "./index.css";
import { withTranslation } from "../../translation";

const ProductBadge = props => (
  <div data-auto-id="productTileBadge" className={styles.container}>
    {getBadgeText(props)}
  </div>
);

ProductBadge.propTypes = {
  type: PropTypes.oneOf(["MixMatch", "MoreColors"]).isRequired,
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(ProductBadge);
